import { Form as BaseForm } from './form'
import type { FormOptions } from './types'

const SCRIPT_PATTERN = /\/(sdk\/)?form(\.umd)?(\.min)?\.js(\?|#|$)/

function currentScript(): HTMLScriptElement | null {
  if (typeof document === 'undefined') return null
  const current = document.currentScript
  if (current instanceof HTMLScriptElement) return current
  const scripts = Array.from(document.querySelectorAll<HTMLScriptElement>('script[src]'))
  return scripts.reverse().find((script) => SCRIPT_PATTERN.test(script.src)) ?? null
}

function originOf(script: HTMLScriptElement | null): string | undefined {
  try {
    return script?.src ? new URL(script.src, window.location.href).origin : undefined
  } catch {
    return undefined
  }
}

export function browserForm(script: HTMLScriptElement | null = currentScript()): typeof BaseForm {
  const origin = originOf(script)
  return class Form extends BaseForm {
    constructor(options: FormOptions) {
      super(options && typeof options === 'object' ? { ...options, apiBase: options.apiBase || origin } : options)
    }
  }
}

export function install(root: Record<string, unknown>): void {
  const script = currentScript()
  const custom = script?.getAttribute('data-global')
  const name = custom || 'Form'
  if (root[name] !== undefined) {
    console.warn(
      custom
        ? `[form] window.${name} já existe e não foi sobrescrito.`
        : '[form] window.Form já existe e não foi sobrescrito. Use o atributo data-global no <script> para escolher outro nome.'
    )
    return
  }
  root[name] = browserForm(script)
}

export { BaseForm as Form }
export default BaseForm
